import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { ATMobilityBenefitActivationDialogExtension } from './extension/at-mobility-benefit-activation-dialog.extension';
import { ATMobilityBenefitColumnsExtension } from './extension/at-mobility-benefit-columns.extension';
import { ATMobilityBenefitMetadataExtension } from './extension/at-mobility-benefit-metadata.extension';
import { ATMobilityBenefitNavigationExtension } from './extension/at-mobility-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('atMobility')
    .add(BenefitMetadataExtensionInterface, new ATMobilityBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new ATMobilityBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new ATMobilityBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new ATMobilityBenefitActivationDialogExtension())
    .build(),
);
